import { Route, AppId, createPageRoute } from '@lumapps/router';

export const tasksAnalyticsRoute: Route = createPageRoute({
    slug: 'analytics/tasks',
    id: 'tasks-analytics',
    appId: AppId.backOffice,
});
